var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"border-radius":"29px"},style:(`${
    _vm.isLoading
      ? 'cursor: not-allowed;'
      : '' } ${
    _vm.isFixed
      ? 'width: fit-content'
      : 'width: 100%'
  }`)},[_c('button',{staticClass:"btn",class:[ _vm.className, {
      disabled: !_vm.canSubmit || _vm.isLoading,
      loading: _vm.isLoading
    }],attrs:{"type":"button","disabled":!_vm.canSubmit || _vm.isLoading},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[(!_vm.isLoading)?_vm._t("default"):_c('div',{staticClass:"preloader"},[_c('div',{staticClass:"loader"})])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }